import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLedgerInfo,
  getLedgerInfoV2,
  getLedgerMode,
} from "../../services/CutomerLedger/CustomerLedger";
import { getUserData } from "../../utils/localStorage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import SchedularModal from "../SchedularModal";
import StatusFilterModal from "../StatusFilterModal";
import { Button } from "primereact/button";
import { DataScroller } from "primereact/datascroller";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { formatDate } from "../../constants/FormateDate";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers";
import {
  localeDateEndDate,
  localeDateStartDate,
} from "../../constants/DateUtil/DateUtil";

const { innerWidth: width, innerHeight: height } = window;

const CustomerLedger = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerData, storeCustomerId, storeIdValue } = location.state || {};

  const { storeData, userProfileRole, brandProfileData } = getUserData();

  const [adminStoreData, setAdminStoreData] = useState({});

  const fetchStoreUser = () => {
    getBrandStoreById(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setAdminStoreData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchStoreUser();
  }, []);

  const storeId = userProfileRole === "BY_STORE" ? storeData.id : storeIdValue;

  let storeName =
    userProfileRole === "BY_STORE"
      ? storeData?.storeName
      : adminStoreData?.storeName;
  let storeFullAddress =
    userProfileRole === "BY_STORE"
      ? storeData?.address?.fullAddress
      : adminStoreData?.address?.fullAddress;
  let mobileNo =
    userProfileRole === "BY_STORE"
      ? storeData?.mobileNo
      : adminStoreData?.mobileNo;

  const [schedularModalVisible, setSchedularModalVisible] = useState(false);
  const [statusFilterModalVisible, setStatusFilterModalVisible] =
    useState(false);
  const [selectedStatus, setSelectedStatus] = useState("ALL"); // Default to show all orders
  const [ledgerMode, setLedgerMode] = useState([]);
  const [customerLedger, setCustomerLedger] = useState([]);
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [isEndReached, setIsEndReached] = useState(false);
  const [useEffectCall, setUseEffectCall] = useState(false);
  const [upDateSelectedStatus, setUpDateSelectedStatus] = useState([]); // Default to show all orders
  const [openingBalanceData, setOpeningBalanceData] = useState(0);
  const [closingBalanceData, setClosingBalanceData] = useState(0);

  const ds = useRef(null);
  const initializeVariable = () => {
    setCustomerLedger([]);
  };
  const handleCalendarModal = () => {
    setSchedularModalVisible(true);
  };

  const handleFilterModal = () => {
    setStatusFilterModalVisible(true);
    // Close the filter modal or perform any other necessary actions
  };

  const formatDateLedger = (dateString) => {
    const parsedDate = new Date(dateString.replace("Z", ""));

    return parsedDate.toLocaleString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour12: true,
    });
  };

  const [schedularDate, setSchedularDate] = useState({});
  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setUseEffectCall(true);
    setPage(0);
    setSchedularDate(newSchedular);
  };

  const receiveDataFromStatusFilterModal = (selectedStatus) => {
    setUseEffectCall(true);
    setPage(0);
    setSelectedStatus(selectedStatus);
  };

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate() - 30); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));

  const handleBackButton = () => {
    navigate("/WalletLedgerSelection", {
      state: {
        customerData: customerData,
        storeCustomerId: storeCustomerId,
        storeId: storeId,
      },
    });
  };

  const data = {
    startDate: localeDateStartDate(new Date(startDate)),
    endDate: localeDateEndDate(new Date(endDate)),
    ledgerModeIn: ledgerMode,
  };
  const [requestData, setRequestData] = useState(data);

  const fetchLedgerMode = () => {
    getLedgerMode() // Return the promise to chain
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setLedgerMode(Res);
          const dataNew = {
            startDate: localeDateStartDate(new Date(startDate)),
            endDate: localeDateEndDate(new Date(endDate)),
            ledgerModeIn: Res,
          };
          fetchCustomerLedger(dataNew);
          fetchCustomerLedgerV2(dataNew);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchLedgerMode();
  }, []);

  const fetchCustomerLedger = (data) => {
    setLoading(true);

    getLedgerInfo(storeCustomerId, storeId, {
      ...data,
      sortOrder: "asc",
      sortBy: "createdDate",
      limit: 70,
      offset: page * 70,
    }) // Return the promise to chain
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // setCustomerLedger((prevData) => [...prevData, ...Res]);
          if (page === 0) {
            setCustomerLedger(Res); // Reset state with new data
          } else {
            setCustomerLedger((prevData) => [...prevData, ...Res]);
          }

          setLoading(false);
          setIsEndReached(Res.length < 70); // Set to true if fewer items are returned
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  const amountSumData = customerLedger?.reduce(
    (acc, item) => acc + item.amount,
    0,
  );

  const fetchCustomerLedgerV2 = (data) => {
    getLedgerInfoV2(storeCustomerId, storeId, {
      ...data,
      sortOrder: "asc",
      sortBy: "createdDate",
      limit: 10,
      offset: 0,
    }) // Return the promise to chain
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOpeningBalanceData(Res.openingBalance);
          setClosingBalanceData(Res.closingBalance);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
        setLoading(false);
      });
  };

  const getData = () => {
    if (!isEndReached && !loading) {
      setPage((prevPage) => prevPage + 1);
      ds.current.load();
    }
  };

  useEffect(() => {
    if (useEffectCall) {
      initializeVariable();
      if (selectedStatus !== "ALL") {
        requestData.ledgerModeIn = selectedStatus;
      } else {
        requestData.ledgerModeIn = ledgerMode;
      }
      requestData.startDate = schedularDate?.startDate
        ? localeDateStartDate(new Date(schedularDate.startDate))
        : localeDateStartDate(new Date(startDate));
      requestData.endDate = schedularDate?.endDate
        ? localeDateEndDate(new Date(schedularDate.endDate))
        : localeDateEndDate(new Date(endDate));
      fetchCustomerLedger(requestData);
      fetchCustomerLedgerV2(requestData);
    }
  }, [schedularDate, selectedStatus]);

  useEffect(() => {
    const requestValue = {
      ...requestData,
      ledgerModeIn: ledgerMode,
    };
    if (page > 0) {
      fetchCustomerLedger(requestValue);
    }
  }, [page]);

  const ledgerModeData = {
    SALE: "#57daf7",
    RECEIPT_ADVANCE_PAYMENT: "#fcfa5d",
    CASH: "#fcfa5d",
    PAYTM: "#fcfa5d",
    ALTER_UP: "#7ff583",
    ORDER_REFUND: "#08d50f",
    SUBS_REFUND: "#08d50f",
    WALLET_REFUND: "#08d50f",
    ALTER_DOWN: "#f86754",
    CANCEL: "#FF6767",
    CHEQUE: "#fcfa5d",
    USER_ACCOUNT: "#f09a1a",
    ONLINE: "#fcfa5d",
    CC: "#fcfa5d",
    DC: "#fcfa5d",
    COD: "#fcfa5d",
    GPAY: "#fcfa5d",
    DEFAULT: "#fff",
  };

  const renderCardItem2 = (item) => {
    const ledgerModeColor =
      ledgerModeData[item.ledgerMode] || ledgerModeData.DEFAULT;

    const particulars =
      item.ledgerMode === "RECEIPT_ADVANCE_PAYMENT"
        ? item.particular.replace(
            "RECEIPT_ADVANCE_PAYMENT - Inv no.",
            "RECEIPT ADVANCE PAYMENT - ",
          )
        : item.ledgerMode === "USER_ACCOUNT"
          ? item.particular.replace("USER_ACCOUNT - Inv no.", "USER ACCOUNT - ")
          : item.ledgerMode === "ALTER_UP"
            ? item.particular.replace("Alter", "Edit ")
            : item.ledgerMode === "ALTER_DOWN"
              ? item.particular.replace("Alter", "Edit ")
              : item.particular.replace("Inv no.", "");

    return (
      <div
        className="flex-1 flex flex-row mx-2 justify-content-between"
        style={{ backgroundColor: `${ledgerModeColor}` }}
      >
        <p className="flex-1 text-lg font-medium border-1 p-1">
          {formatDateLedger(item.createdDate)}
        </p>
        <p className="flex-1 text-lg font-medium border-1 p-1">{particulars}</p>
        <p className="flex-1 text-lg font-medium text-right border-1 p-1">
          {" " + item.amount}
        </p>
      </div>
    );
  };

  let rows = "";

  customerLedger.forEach((entry) => {
    const ledgerModeColorHtml =
      ledgerModeData[entry.ledgerMode] || ledgerModeData.DEFAULT;

    const particularsHtml =
      entry.ledgerMode === "RECEIPT_ADVANCE_PAYMENT"
        ? entry.particular.replace(
            "RECEIPT_ADVANCE_PAYMENT - Inv no.",
            "RECEIPT ADVANCE PAYMENT - ",
          )
        : entry.ledgerMode === "USER_ACCOUNT"
          ? entry.particular.replace(
              "USER_ACCOUNT - Inv no.",
              "USER ACCOUNT - ",
            )
          : entry.ledgerMode === "ALTER_UP"
            ? entry.particular.replace("Alter", "Edit ")
            : entry.ledgerMode === "ALTER_DOWN"
              ? entry.particular.replace("Alter", "Edit ")
              : entry.particular.replace("Inv no.", "");

    rows += `
    <div class="table-head">
      <div class="table-cell-head">${formatDateLedger(entry.createdDate)}</div>
      <div class="table-cell-head">${particularsHtml}</div>
      <div class="table-cell-head2">${
        (entry.ledgerMode === "ALTER_UP"
          ? "+"
          : entry.ledgerMode === "ALTER_DOWN"
            ? "-"
            : "") +
        " " +
        entry.amount
      }</div>
    </div>`;
  });

  const rowClass = (rowData) => {
    return `row-${rowData.ledgerMode}`; // e.g., "row-credit"
  };

  const RenderTabView = () => {
    return (
      <DataTable
        showGridlines
        value={customerLedger}
        // header={header}
        paginator
        rows={15}
        rowsPerPageOptions={[15, 50, 75, 100]}
        rowClassName={rowClass}
        stripedRows
        scrollable
        scrollHeight={height - 220}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) => options.rowIndex + 1}
        ></Column>
        <Column
          field="Date"
          header="Date"
          body={(rowData) => formatDateLedger(rowData.createdDate)}
        ></Column>
        <Column
          field="Particular"
          header="Particular"
          body={(rowData) =>
            rowData.ledgerMode === "RECEIPT_ADVANCE_PAYMENT"
              ? rowData.particular.replace(
                  "RECEIPT_ADVANCE_PAYMENT - Inv no.",
                  "RECEIPT ADVANCE PAYMENT - ",
                )
              : rowData.ledgerMode === "USER_ACCOUNT"
                ? rowData.particular.replace(
                    "USER_ACCOUNT - Inv no.",
                    "USER ACCOUNT - ",
                  )
                : rowData.ledgerMode === "ALTER_UP"
                  ? rowData.particular.replace("Alter", "Edit ")
                  : rowData.ledgerMode === "ALTER_DOWN"
                    ? rowData.particular.replace("Alter", "Edit ")
                    : rowData.particular.replace("Inv no.", "")
          }
        ></Column>
        <Column
          field="Amount"
          header="Amount"
          body={(rowData) => rowData?.amount}
        ></Column>
      </DataTable>
    );
  };

  const downloadPDF = (type) => {
    const doc = new jsPDF("landscape");
    const logoImg = new Image();

    if (brandProfileData.logo) {
      try {
        const base64String = `data:image/png;base64,${brandProfileData.logo}`;
        doc.addImage(base64String, "PNG", 250, 10, 40, 40);
      } catch (err) {
        console.warn("Failed to add logo image to PDF:", err);
      }
    }

    const formatDateLedger = (date) => {
      if (!date) return "";
      const d = new Date(date);
      return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${d.getFullYear()}`;
    };

    // Safely get earliest and latest dates from customerLedger
    const allDates = customerLedger
      .map((item) => new Date(item.createdDate))
      .filter((d) => !isNaN(d)); // Filter out invalid dates

    // Get min and max dates
    const minDate = new Date(Math.min(...allDates));
    const maxDate = new Date(Math.max(...allDates));

    // Format them
    const dateFirst = formatDateLedger(minDate);
    const dateSecond = formatDateLedger(maxDate);

    doc.setFontSize(20); // Smaller size for date range
    doc.text(`Customer Ledger`, 110, 10);

    doc.setFontSize(14); // Smaller size for date range
    doc.text(`${storeName}`, 10, 15);

    doc.setFontSize(12); // Smaller size for date range
    doc.text(`${storeFullAddress}`, 10, 21);

    doc.setFontSize(12);
    doc.text(`Store Mobile No. - ${mobileNo}`, 10, 27);

    doc.setFontSize(14);
    doc.text(
      `${customerData?.brandCustomer?.firstName} ${customerData?.brandCustomer?.lastName}`,
      10,
      33,
    );

    doc.setFontSize(12);
    doc.text(`Mobile No. - ${customerData?.brandCustomer?.mobile}`, 10, 39);

    doc.setFontSize(12); // Smaller size for date range
    doc.text(`Duration - ${dateFirst} - ${dateSecond}`, 10, 45);

    doc.setFontSize(12); // Smaller size for date range
    doc.text(
      `Opening Balance (${openingBalanceData}) +  Transaction (${amountSumData}) = Closing Balance (${closingBalanceData})`,
      10,
      51,
    );

    // Format the table data from customerLedger
    const tableData = customerLedger.map((item) => {
      const ledgerModeColor =
        ledgerModeData[item.ledgerMode] || ledgerModeData.DEFAULT;

      // Format the particulars based on ledgerMode
      const particulars =
        item.ledgerMode === "RECEIPT_ADVANCE_PAYMENT"
          ? item.particular.replace(
              "RECEIPT_ADVANCE_PAYMENT - Inv no.",
              "RECEIPT ADVANCE PAYMENT - ",
            )
          : item.ledgerMode === "USER_ACCOUNT"
            ? item.particular.replace(
                "USER_ACCOUNT - Inv no.",
                "USER ACCOUNT - ",
              )
            : item.ledgerMode === "ALTER_UP"
              ? item.particular.replace("Alter", "Edit ")
              : item.ledgerMode === "ALTER_DOWN"
                ? item.particular.replace("Alter", "Edit ")
                : item.particular.replace("Inv no.", "");

      // Return the row in the structure expected by autoTable
      return [
        formatDateLedger(item.createdDate), // Date
        particulars, // Particulars
        (item.ledgerMode === "ALTER_UP"
          ? "+"
          : item.ledgerMode === "ALTER_DOWN"
            ? "-"
            : "") +
          " " +
          item.amount, // Amount
      ];
    });

    // Define table headers
    const tableHeaders = ["Date", "Particular", "Amount"];

    // Generate the table using autoTable
    doc.autoTable({
      head: [tableHeaders],
      body: tableData,
      startY: 56, // Start position for the table
      theme: "grid",
      styles: {
        fontSize: 10,
      },
    });

    // Handle either print or download based on the `type` argument
    if (type === "print") {
      // Create blob URL and open it in a new window for printing
      const blob = doc.output("blob");
      const blobURL = URL.createObjectURL(blob);
      const printWindow = window.open(blobURL);
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } else {
      let date = new Date();
      // Save as PDF file
      doc.save(
        `customer_ledger_${customerData?.brandCustomer?.firstName}_${
          customerData?.brandCustomer?.lastName
        }_${Math.floor(date.getTime() + date.getSeconds() / 2)}`,
      );
    }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Customer Ledger
              </p>
            </div>
          </div>

          <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
            <div onClick={() => handleCalendarModal()}>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
                style={{ width: height < 600 ? 25 : 30 }}
              />
            </div>
          </div>
          <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
            <div onClick={() => handleFilterModal("DELIVERED")}>
              <img
                src={"Laundy_App_Icons_Gifs/Other_Icons/filter.png"}
                style={{ width: height < 600 ? 25 : 30 }}
              />
            </div>
          </div>
          {customerLedger.length > 0 && (
            <div className="flex justify-content-center align-items-center">
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={() => downloadPDF("download")}
                  src={"images/file.png"}
                  style={{
                    width: height < 600 ? 25 : 30,
                  }}
                />
              </div>
              <div className="flex justify-content-center align-items-center cursor-pointer mx-2">
                <img
                  onClick={() => downloadPDF("print")}
                  src={"Icons/printer.png"}
                  style={{
                    width: height < 600 ? 25 : 30,
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          flexDirection: "row",
          alignItems: "center",
          marginHorizontal: 10,
          borderTopWidth: 0.5,
          borderColor: "#000",
          justifyContent: "space-between",
        }}
      ></div>

      <div
        className="flex gap-3 my-2 mx-4 pb-1 new-scroll-bar"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <p className="text-lg font-bold">
          Period:{" "}
          {schedularDate?.startDate
            ? formatDate(schedularDate?.startDate)
            : formatDate(startDate)}{" "}
          -{" "}
          {schedularDate?.endDate
            ? formatDate(schedularDate?.endDate)
            : formatDate(endDate)}
        </p>
      </div>

      <div
        className="flex gap-3 my-2 mx-4 pb-1 new-scroll-bar"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <div
          style={{ backgroundColor: "#55BD5A" }}
          className="px-3 py-2 border-round-md"
        >
          <p className="text-white text-lg font-bold uppercase">
            Opening Balance: {openingBalanceData}
          </p>
        </div>

        <div
          style={{ backgroundColor: "#F5C43A" }}
          className="px-3 py-2 border-round-md"
        >
          <p className="text-white text-lg font-bold uppercase">+</p>
        </div>

        <div
          style={{ backgroundColor: "#3EB3E1" }}
          className="px-3 py-2 border-round-md"
        >
          <p className="text-white text-lg font-bold uppercase">
            Transaction: {amountSumData}
          </p>
        </div>

        <div
          style={{ backgroundColor: "#F5C43A" }}
          className="px-3 py-2 border-round-md"
        >
          <p className="text-white text-lg font-bold uppercase">=</p>
        </div>

        <div
          style={{ backgroundColor: "#FF6767" }}
          className="px-3 py-2 border-round-md"
        >
          <p className="text-white text-lg font-bold uppercase">
            Closing Balance: {closingBalanceData}
          </p>
        </div>
      </div>

      {loading ? (
        <div style={{ flex: 1 }}>
          <div className="text-center">
            <ProgressSpinner
              style={{ width: "70px", height: "70px" }}
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration="2s"
            />
          </div>
        </div>
      ) : customerLedger?.length > 0 ? (
        <div>
          <div>
            <div className="scroll-bar mb-2">
              <div className="mx-4 mt-4 report-table">
                <div className="tab-view-table">{RenderTabView()}</div>
              </div>
            </div>
          </div>
          <div style={{ display: "none" }}>
            <DataScroller
              value={customerLedger}
              itemTemplate={renderCardItem2}
              rows={customerLedger?.length + 100}
              inline
              ref={ds}
              scrollHeight={height - 200}
              loader
              // footer={footer}
            />
          </div>
        </div>
      ) : (
        <div className="flex justify-content-center align-items-center">
          <p className="text-xl font-semi-bold">No Order Found</p>
        </div>
      )}

      <div
        className="flex justify-content-center fixed "
        style={{ bottom: 20, left: 20 }}
      >
        <Button
          type="text"
          icon="pi pi-plus"
          // label="More"
          onClick={getData} // Update this to trigger `getData`
        />
      </div>
      <SchedularModal
        setSchedularModalVisible={setSchedularModalVisible}
        schedularModalVisible={schedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
      />
      <StatusFilterModal
        setStatusFilterModalVisible={setStatusFilterModalVisible}
        statusFilterModalVisible={statusFilterModalVisible}
        sendDataToOrdersPageFromFilter={receiveDataFromStatusFilterModal}
        upDateSelectedStatus={upDateSelectedStatus}
        OrderStatus={ledgerMode}
      />
    </div>
  );
};

export default CustomerLedger;
